"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var SvgAdministration = function SvgAdministration(props) {
  return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], props, /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("style", null, '.administration_svg__cls-1{fill:#333}')), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.25 17.21l-4.68-4.68-1.52 1.52 4.8 4.56-1.4 1.39-4.8-4.56-1.28 1.28 4.68 4.68a2 2 0 002.8 0l1.4-1.4a2 2 0 000-2.79zM4.8 7.91l1.61.2 2.61 2.48 1.4-1.41-2.61-2.47-.2-1.61-.88-.52-.87-.53-.88-.52L4.1 3l-.35.35-.35.35-.35.35-.35.35.53.88.52.88.53.87.52.88z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.3 10.1a4.15 4.15 0 00.8-4.73l-2.76 2.77-2-2 2.77-2.76a4.14 4.14 0 00-5.77 4.91l-9.76 9.86A2 2 0 006.39 21l9.78-9.83a4.15 4.15 0 004.13-1.07z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none",
    id: "administration_svg__Bounding_Boxes",
    "data-name": "Bounding Boxes"
  }));
};

var _default = SvgAdministration;
exports["default"] = _default;